import script from "./HomeAdvantage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeAdvantage.vue?vue&type=script&setup=true&lang=js"

import "./HomeAdvantage.vue?vue&type=style&index=0&id=7d0b0ebd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0b0ebd"]])

export default __exports__